

















































































































































































































































































































































































































import cloneDeep from 'lodash/cloneDeep';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import { buildShiftFactListWorkbook, buildShiftFactJournalWorkbook, shiftFactListFilename, shiftFactJournalFilename, ShiftFactListExportRow } from '@/modules/ShiftDetails/shiftFactXlsx';
import { saveAs } from 'file-saver';

import TitleBar from '@/components/Elements/TitleBar.vue'
import moment from 'moment';
import XLSX from 'xlsx';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter', 'previewDealProducts',

      'documents', 'lastMeta', 'stats', 'meta'
    ]),
  },
  // methods: {
  //   ...mapActions(STORE_KEY, ['copyDeal']),
  // },
  components: {
    TitleBar,
  }
})
export default class ShiftsList extends Vue {
  radioButton = 1;
  previewRow = null;

  master: any = null;
  operator: any = null;
  line: any = null;
  targetDates: any[] = [];

  open = false;
  prevent = false;

  get titleStack () {
    return [
      'Смены'
    ]
  }

  getQueryParam(field: string) {
    return this.$route.query ? cloneDeep(this.$route.query[field]) : null
  }

  // ---------------------------------------------------------------------------

  get clientTypes() {
    return [
      {
        id: 'client',
        label: 'Клиент'
      },
      {
        id: 'partner',
        label: 'Партнер'
      },
      {
        id: 'supplier',
        label: 'Поставщик'
      }
    ]
  }

  filterForm: any = {}
  dealsIds: any = []

  get filtersCount() {
    return Object.keys(this.filterForm).reduce((cur: number, filterKey: any) => {
      return cur + ((this.filterForm[filterKey] && this.filterForm[filterKey].length > 0) ? 1 : 0);
    }, 0);
  }

  @Watch('$route.query')
  public checkFilterChange() {
    this.master = this.getQueryParam('master');
    this.operator = this.getQueryParam('operator');
    this.line = this.getQueryParam('template');

    if (this.getQueryParam('since')) {
      this.targetDates = [
        // @ts-ignore
        moment(this.$route.query.since).toDate(),
        // @ts-ignore
        moment(this.$route.query.until).toDate()
      ]
    }
  }

  clearDate() {
    this.targetDates = []
    this.$router.replace({
      query: {
        ...this.$route.query,
        since: null,
        until: null,
      }
    })
  }


  onFilterChange(filter: string, value: any) {
    console.log('onFilterChange', filter, value)
    const query = { ...this.$route.query}
    query[filter] = value
    this.$router.replace({
      query
    })
  }

  onDatesChange(dates: any) {
    console.log('onDatesChange', dates)
    this.$router.replace({
      query: {
        ...this.$route.query,
        since: moment(dates[0]).format('YYYY-MM-DD'),
        until: moment(dates[1]).format('YYYY-MM-DD'),
      }
    })
  }

  // ---------------------------------------------------------------------------

  get defaultSort() {
    return [this.$route.query.sortField || 'created_at', this.$route.query.sortDirection || 'desc']
  }

  get selectedView() {
    return this.$route.query.view || 'data'
  }

  get selectedDealsView() {
    return this.$route.query.deals_view || 'deals'
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }

  private delayFilter: any = null


  onPageChange(page: string) {
    console.log('onPageChange', page)
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }
  exportAsXLSX() {
    this.$buefy.snackbar.open(`Начало экспорта данных. Данная процедура может занять некоторое время.`);

    this.$store.dispatch(`${STORE_KEY}/exportDataAsXLSX`, {
      ...this.$route.query
    }).then(() => {
      this.$buefy.snackbar.open(`Экспорт окончен. Файл должен был скачаться на ваш ПК.`);
    }).catch(() => {
      this.$buefy.snackbar.open(`При экспорте данных произошла ошибка.`);
    });
  }

  /**
   * Выгрузка журналов факта (XLSX) для смен, выбранных галочками.
   * Берутся только линии АТОМ и Общая; ВДП и мойки игнорируются.
   * «Количество» — зарегистрированный факт («Кол-во выпущенного продукта, шт»),
   * а не плановое значение партии.
   * «Общий» — все смены на одном листе (без колонок факт/карантин/примечание);
   * «По сменам» — каждая смена на отдельном листе с шапкой
   * «дата (смена), мастер, принял».
   */

  /** Загружает факты выбранных смен и собирает плоский список строк; при пустом результате показывает toast и возвращает null */
  private async fetchFactExportRows(): Promise<ShiftFactListExportRow[] | null> {
    const shifts: any[] = this.dealsIds || [];

    if (process.env.NODE_ENV === 'development') {
      console.debug('[ShiftsList] export fact journal: selected shifts=', shifts.length,
        shifts.map((shift: any) => ({ id: shift.id, template: shift.template })));
    }

    const result: any = await this.$store.dispatch(`${STORE_KEY}/exportFactBlanks`, { shifts });

    if (result.skippedAll) {
      this.$buefy.toast.open({
        type: 'is-warning',
        message: 'В выбранных сменах нет линий АТОМ или Общая',
      });
      return null;
    }

    const shiftsById: any = {};
    shifts.forEach((shift: any) => { shiftsById[shift.id] = shift; });

    /** Мастер смены из работников (роль с признаком руководящей) */
    const masterOf = (shift: any): string => {
      const manager = (shift?.workers || []).find((worker: any) => worker.is_manager);
      return manager?.employee_name || '';
    };

    const rows: ShiftFactListExportRow[] = [];
    const pushFacts = (facts: any[], isAtom: boolean) => {
      (facts || []).forEach((fact: any) => {
        const shift = shiftsById[fact.shift_id];
        if (!shift) return;
        rows.push({
          shift_date: shift.shift_date,
          times_of_day: shift.times_of_day,
          template: shift.template,
          master_name: masterOf(shift),
          batch_number: fact.number,
          product_name: fact.product_name,
          container_name: (isAtom ? fact.fact_container_name : null) || fact.container_name,
          quantity: fact.fact_quantity,
        });
      });
    };
    pushFacts(result.atom, true);
    pushFacts(result.custom, false);

    if (rows.length === 0) {
      this.$buefy.toast.open({
        type: 'is-warning',
        message: 'В выбранных сменах нет записей факта',
      });
      return null;
    }

    return rows;
  }

  private saveFactWorkbook(buffer: ArrayBuffer, filename: string) {
    if (process.env.NODE_ENV === 'development') {
      console.debug('[ShiftsList] export fact journal file=', filename, ', bytes=', buffer?.byteLength);
    }
    saveAs(new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }), filename);
    this.$buefy.toast.open('Файл выгружен');
  }

  private async exportFactJournal(byShifts: boolean) {
    try {
      const rows = await this.fetchFactExportRows();
      if (!rows) return;

      if (process.env.NODE_ENV === 'development') {
        console.debug('[ShiftsList] export fact journal: rows=', rows.length, ', byShifts=', byShifts);
      }

      const buffer = byShifts
        ? await buildShiftFactJournalWorkbook(rows)
        : await buildShiftFactListWorkbook(rows);
      this.saveFactWorkbook(buffer, byShifts ? shiftFactJournalFilename() : shiftFactListFilename());
    } catch (err) {
      console.error('[ShiftsList] export fact journal error', err);
      this.$buefy.toast.open({
        type: 'is-warning',
        message: 'Не удалось выгрузить файл. Попробуйте позже.',
      });
    }
  }

  /** Общий журнал: все смены на одном листе */
  public exportFactCommon() {
    return this.exportFactJournal(false);
  }

  /** Журнал по сменам: каждая смена на отдельном листе */
  public exportFactByShifts() {
    return this.exportFactJournal(true);
  }

  // ---------------------------------------------------------------------------

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.checkFilterChange();
    this.handleParamsChange();
  }

  // beforeDestroy() {
  //   this.$store.unregisterModule(STORE_KEY);
  // }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.previewRow = null;
    this.prevent = false;
    if (this.$route.query.view == 'stats') {
      this.$store.dispatch(`${STORE_KEY}/loadStatistic`, {
        ...this.$route.query
      });
    } else {
      this.$store.dispatch(`${STORE_KEY}/loadData`, {
        ...{
          sortField: this.$route.query.sortField || 'created_at',
          sortDirection: this.$route.query.sortDirection || 'desc'
        },
        ...this.$route.query
      });
    }
  }

}
